import {useEffect, useState} from "react";
import ajaxService from "../../../utils/ajaxServices";
import config from "../../../config/index";

let fetched = false;

export default function Footer({hidden = false}){
    const env = config.env;
    const drupal = config.envConfigs[env].drupalApi.url;
    const [menuFragment, setMenuFragment] = useState("");
    useEffect(()=>{
        const getNavigation = async () => {
            fetched = true;
            let fragment = await ajaxService.httpGet(
                "drupalBaseUrl",
                "",
                "api",
                "footerFragment","","text");
            if(fragment){
                const abslutePath = fragment.replace(/src="\//g,`src="${drupal}/`)
                setMenuFragment(abslutePath)
            }
        }
        if (!fetched) getNavigation();
    },[])
    return <footer id="footerFragment" dangerouslySetInnerHTML={{ __html: menuFragment}} className={hidden ? "d-none" : ""}></footer>
}